export const OrderType = {
    Tv: 'TV',
    Internet: 'Internet',
    OOH: 'OOH',
    Radio: 'Radio',
    DA: 'DA'
}

export const SaleTypeShortName = {
    Cennik: 'None',
    Pakiet: 'Ratings',
    Punktowe: 'Spot',
    Spotowe: 'Floating ratecard'
}

export const SpotTypeShortName = {
    Reklama: 'ADSPOT'
}

export const PackageTypeShortName = {
    Zlecenie_indywidualne: 'IND'
}
